module.exports = __webpack_public_path__ + "img/talco o polvo dermico.7f41efe6.png";